import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateProjectOrganizationStatus = async (
  projectId,
  organizationChartItemIdToApprove,
  status
) => {
  const apiPath = `organization-charts/project/${projectId}/organization/${organizationChartItemIdToApprove}/update-organization-status`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { status },
  });

  const response = await axios(signedRequest);

  return response.data;
};
